import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axios, axiosAuth, errorHandling } from "../helpers";

const initialState = {
    data: {},
    isLogin: false,
    status: "idle", //'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
};

export const loginAction = createAsyncThunk("login", async (form) => {

    try {
        const response = await axiosAuth.post(`${form.type === "pegawai" ? "/v1/login" : "/v1/admin/login"}`, form);

        localStorage.setItem("otp_token", response.data.data.token)
        //  if(response.data.data.enable_2fa)
        return response
    } catch (err) {
        console.log(err);
        return errorHandling(err);
    }
});
export const verifyOtpAction = createAsyncThunk(
    "otp/verify",
    async (payload) => {
        try {
            const response = await axiosAuth.post("/v1/otp/verify", payload)
            return response
        } catch (err) {
            return errorHandling(err)
        }
    }
)


const loginSlice = createSlice({
    name: "login",
    // initialState: {
    //     token_account: "",
    //     token_disposisi: "",
    //     token_tte: "",
    //     isLogin: false,
    //     status: "idle",
    //     error: null,
    // },
    initialState: {
        token_account: "",
        token_disposisi: "",
        token_tte: "",
        isLogin: false,
        status: "idle",
        otpStatus: "idle",
        enable2FA: null,
        error: null,
    },
    reducers: {
        changeTokenApp: (state, action) => {
            if (action.payload.app === "disposisi") {
                state.token_disposisi = action.payload.token
            } else {
                state.token_tte = action.payload.token
            }
        },
        enterPage: (state) => {
            state.status = "idle";
            state.error = null;
        },
        logout: (state) => {
            state.status = "idle";
            state.isLogin = false;
            state.token_account = null
            state.token_disposisi = null
            state.token_tte = null
        },
        updateAccountToken: (state, action) => {
            state.token_account = action.payload;
        },
    },
    extraReducers(builder) {
        builder.addCase(loginAction.pending, (state) => {
            state.status = "loading";
        });
        builder.addCase(loginAction.fulfilled, (state, action) => {
            if (action.payload.data && action.payload.data.status_code === 200) {
                const data = action.payload.data.data

                state.status = "succeeded"
                // state.isLogin = true
                state.token_account = data.token
                state.enable2FA = data.enable_2fa
                state.error = null
            } else {
                state.status = "failed"
                state.error = action.payload
            }
        })

        builder.addCase(loginAction.rejected, (state, action) => {
            state.status = "failed";
            console.log(action.error.message);
            state.error = action.error.message;
        });
        //new
        builder.addCase(verifyOtpAction.pending, (state) => {
            state.otpStatus = "loading"
        })

        builder.addCase(verifyOtpAction.fulfilled, (state, action) => {
            if (action.payload.data?.message === "success") {
                state.otpStatus = "succeeded"
                state.token_account = action.payload.data.data.token
                state.isLogin = true
                state.error = null
            } else {
                state.otpStatus = "failed"
                state.error = action.payload
            }
        })

        builder.addCase(verifyOtpAction.rejected, (state, action) => {
            state.otpStatus = "failed"
            state.error = action.error.message
        })


    },
});

export const loginData = (state) => state.login;
export const { logout, enterPage, changeTokenApp,updateAccountToken } = loginSlice.actions;
export const otpData = (state) => ({
    status: state.login.otpStatus,
    error: state.login.error,
})

export default loginSlice.reducer;